var React = require('react');

function ArrowHover (props) {
    return React.createElement("svg",props,[React.createElement("g",{"fill":"#fff","fillRule":"evenodd","className":"arrow__path","key":0},[React.createElement("path",{"d":"M0 7.325h24.729V9.22H0z","key":0}),React.createElement("path",{"d":"M19.343.687l7.472 7.585-1.305 1.362-7.472-7.585z","key":1}),React.createElement("path",{"d":"M18.002 14.595l7.437-7.683 1.376 1.36-7.364 7.698z","key":2})]),React.createElement("g",{"fill":"#fff","fillRule":"evenodd","className":"arrow-fixed__path","key":1},[React.createElement("path",{"d":"M0 7.325h24.729V9.22H0z","key":0}),React.createElement("path",{"d":"M19.343.687l7.472 7.585-1.305 1.362-7.472-7.585z","key":1}),React.createElement("path",{"d":"M18.002 14.595l7.437-7.683 1.376 1.36-7.364 7.698z","key":2})])]);
}

ArrowHover.defaultProps = {"width":"27","height":"16","viewBox":"13 0 32 18","className":"arrow"};

module.exports = ArrowHover;

ArrowHover.default = ArrowHover;
